export default __webpack_public_path__ + "static/media/denise-artworkinfo1.4eb8748e.jpeg";